(function () {
  'use strict';

  function isProtectedImage(el) {
    if (!el || el.tagName !== 'IMG') return false;
    if (el.closest('.header__heading-logo, [data-no-image-protect]')) return false;
    return true;
  }

  document.addEventListener('contextmenu', function (e) {
    if (isProtectedImage(e.target)) e.preventDefault();
  }, false);

  document.addEventListener('dragstart', function (e) {
    if (isProtectedImage(e.target)) e.preventDefault();
  }, false);
})();
